<template>
    <ModalComponent
        name="pagar-plazos"
        title="Pagar plazos"
        v-on:close="close"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <PagoComponent :importe="importe" @terminado="submit" @close="close()"/>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from '@/components/backend/components/ModalComponent';
    import PagoComponent from './PagoComponent';

    export default {
        props: ['importe', 'ruta', 'params'],
        data() {
            return {
                loading: false,
                metodo_pago: null
            }
        },
        methods: {
            close() {
                this.$emit('close', 'pagar-plazos');
            },
            pagarPlazos() {
                this.$emit('terminado', this.metodo_pago);
            },
            async submit(metodo_pago) {
                this.metodo_pago = metodo_pago;

                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.pagarPlazos();
                }
            }
        },
        components: { ModalComponent, PagoComponent }
    }
</script>